module.exports = __webpack_public_path__ + "img/gif.b7d47b3d.png";